import { REQUEST_PLANS, REQUEST_PLANS_SUCCEEDED } from './plansActions';

const InitialState = {};

export default function plansByCarrierIdReducer(state = InitialState, action) {
    const {
        type,
        payload,
    } = action;

    switch (type) {
        case REQUEST_PLANS:
            return {
                ...state,
                [payload.carrierId]: [],
            };

        case REQUEST_PLANS_SUCCEEDED:
            return {
                ...state,
                [payload.carrierId]: payload.plans,
            };

        default:
            return state;
    }
}
